export const DYNAMIC_CONTACT_FIELDS = [
  { key: 'customer_name', label: 'Customer Name', sample: 'Kabir Sharma' },
  { key: 'first_name', label: 'First Name', sample: 'Kabir' },
  { key: 'phone', label: 'Phone Number', sample: '+91 98765 43210' },
  { key: 'company_name', label: 'Company Name', sample: 'Acme Co' },
  { key: 'pending_fee', label: 'Pending Fee', sample: '3500', windex: true },
  { key: 'student_class', label: 'Student Class', sample: '5A', windex: true },
  {
    key: 'academic_year',
    label: 'Academic Year',
    sample: '2025-26',
    windex: true,
  },
];

const FIELD_BY_KEY = Object.fromEntries(
  DYNAMIC_CONTACT_FIELDS.map((field) => [field.key, field]),
);

const FIELD_KEYS = DYNAMIC_CONTACT_FIELDS.map((field) => field.key).join('|');

/** Only {{field_key}} is a contact mapping. Plain text stays static. */
const TOKEN = new RegExp(`\\{\\{\\s*(${FIELD_KEYS})\\s*\\}\\}`, 'g');

export function contactFieldToken(key) {
  return FIELD_BY_KEY[key] ? `{{${key}}}` : '';
}

export function contactFieldKeyFromValue(value) {
  const match = String(value ?? '')
    .trim()
    .match(new RegExp(`^\\{\\{\\s*(${FIELD_KEYS})\\s*\\}\\}$`));
  return match ? match[1] : '';
}

function feeNumber(value) {
  const digits = String(value ?? '').replace(/[^\d.]/g, '');
  return digits === '' ? '0' : digits;
}

export function buildRecipientVariables(contacts, year) {
  const map = {};
  for (const contact of contacts) {
    const studentClass =
      contact.student_class || contact.class_name || contact.class || '';
    const attrs = {
      pending_fee: feeNumber(contact.pending_fee),
    };
    if (studentClass) attrs.student_class = String(studentClass);
    if (year || contact.academic_year) {
      attrs.academic_year = String(year || contact.academic_year);
    }
    const entry = attrs;
    if (contact.id != null && contact.id !== '')
      map[String(contact.id)] = entry;
    if (contact.phone) map[String(contact.phone)] = entry;
  }
  return map;
}

export function sumPendingFees(contacts) {
  return contacts.reduce(
    (sum, contact) => sum + Number(feeNumber(contact.pending_fee)),
    0,
  );
}

export function splitDynamicPreview(value) {
  const text = String(value ?? '');
  const parts = [];
  let last = 0;
  for (const match of text.matchAll(TOKEN)) {
    const index = match.index ?? 0;
    if (index > last) {
      parts.push({ type: 'text', text: text.slice(last, index) });
    }
    const key = match[1];
    parts.push({ type: 'field', field: FIELD_BY_KEY[key] });
    last = index + match[0].length;
  }
  if (last < text.length) parts.push({ type: 'text', text: text.slice(last) });
  return parts;
}

export function describeVariableValue(value) {
  const text = String(value ?? '').trim();
  const parts = splitDynamicPreview(text);
  const fields = parts.filter((part) => part.type === 'field');
  if (
    fields.length === 1 &&
    parts.every((part) => part.type === 'field' || !part.text.trim())
  ) {
    return { text: fields[0].field.label, kind: 'Dynamic' };
  }
  if (fields.length > 0) return { text, kind: 'Dynamic' };
  return { text, kind: 'Static' };
}
